// src/entry.js — bundle entry for the Vital production build.
//
// Full bundle (Step 3): all source files from the original index.html load
// list, in the same order. This is the input that produces the dist/app.js
// served to both the bundled web build and the Capacitor iOS WebView.
//
// IMPORTANT — import order matters. esbuild executes imported modules in
// the order they appear below; each module's body must finish before the
// next one runs. setup-globals must be first so React/ReactDOM globals
// exist; supabase-config must be second so window.sb exists before db.js
// reads it at load time. The remaining order mirrors index.html.

import './setup-globals.js';
import './supabase-config.js';
import './capacitor-bridge.js';
import './apple-nonce.js';

import '../db.js';
import '../data.js';
// Shared regulatory facts — the SAME file the marketing site loads, so app and
// site can never render different CNE numbers. Plain .js, so it self-publishes
// via Object.assign(window, …); see the header in cne-facts.js.
import '../cne-facts.js';
import '../crowdsource-fields.js';
// Layer 1A deterministic review findings (submission-findings.js). Plain .js,
// so it self-publishes via Object.assign(window, …) like cne-facts.js; the
// names are listed in build.mjs's required-globals so a dropped export fails
// the build instead of silently removing the findings from the review card.
import '../submission-findings.js';
import '../hk-hospitals.js';
import '../ios-frame.jsx';
import '../tweaks-panel.jsx';
import '../motion-kit.jsx';
import '../logo.jsx';
import '../components.jsx';
import '../nav.jsx';
import '../auth.jsx';
import '../onboarding.jsx';
import '../record-extras.jsx';
import '../qualifications.jsx';
import '../screens.jsx';
import '../cne-info.jsx';
import '../paywall.jsx';
import '../discover-filters.jsx';
import '../providers-screen.jsx';
import '../app.jsx';
